import { useEffect, useState } from 'react';
import { useDataGridApiRefContext } from '../../../DataGridApiRefContext';

export const useHeaderHovered = (field: string): boolean => {
  const [hovered, setHovered] = useState(false);
  const { apiRef } = useDataGridApiRefContext();

  useEffect(() => {
    if (!apiRef) {
      return;
    }

    const columnHeaderElement = apiRef.getColumnHeaderElement(field);

    if (!columnHeaderElement) {
      return;
    }

    let skipMouseLeave = false;

    const handleMouseEnter = () => {
      setHovered(true);
    };
    const handleMouseLeave = () => {
      if (skipMouseLeave) {
        skipMouseLeave = false;
        return;
      }

      setHovered(false);
    };
    const handleClick = () => {
      skipMouseLeave = true;
    };

    columnHeaderElement.addEventListener('mouseenter', handleMouseEnter);
    columnHeaderElement.addEventListener('mouseleave', handleMouseLeave);
    columnHeaderElement.addEventListener('click', handleClick);

    return () => {
      columnHeaderElement.removeEventListener('mouseenter', handleMouseEnter);
      columnHeaderElement.removeEventListener('mouseleave', handleMouseLeave);
      columnHeaderElement.removeEventListener('click', handleClick);
    };
  }, [apiRef, field]);

  return hovered;
};
